import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { programApi } from './api'
export function EventProgramLinks({
  eventId,
  productionId,
  admin = false,
}: {
  eventId: string
  productionId?: string
  admin?: boolean
}) {
  const [links, setLinks] = useState<Array<{ id: string; slug: string }>>([])
  useEffect(() => {
    let active = true
    const promise =
      admin && productionId
        ? programApi
            .forProduction(productionId)
            .then((programs) => programs.filter((p) => p.eventId === eventId))
        : programApi.publicForEvent(eventId)
    void promise
      .then((programs) => {
        if (active) setLinks(programs)
      })
      .catch(() => {
        if (active) setLinks([])
      })
    return () => {
      active = false
    }
  }, [eventId, productionId, admin])
  return (
    <div className="flex flex-wrap gap-3">
      {links.map((p) => (
        <Link
          className="inline-block min-h-11 rounded border px-4 py-2 underline"
          key={p.id}
          to={
            admin && productionId
              ? `/admin/productions/${productionId}/program/${p.id}`
              : `/program/${p.slug}/`
          }
        >
          {admin ? 'Edit digital program' : 'View digital program'}
        </Link>
      ))}
      {admin && productionId && links.length === 0 && (
        <Link
          className="inline-block min-h-11 py-2 underline"
          to={`/admin/productions/${productionId}`}
        >
          Set up digital program in production
        </Link>
      )}
    </div>
  )
}
